/**
 * @function moveImageAsBackground
 * Toggles between moving image source to background-image or restoring original img element.
 *
 * @param {string} imgSelector - CSS selector for the image element
 * @param {string} targetSelector - CSS selector for the target element
 * @param {boolean} applyBackground - If true, applies background image; if false, restores original img
 */
function moveImageAsBackground(imgSelector, targetSelector, applyBackground = true) {
	const images = document.querySelectorAll(imgSelector);

	// Guard clause: return early if no images are found
	if (images.length === 0) {
		return;
	}

	images.forEach((img) => {
		// Find the target element relative to the image
		const targetElement = img.closest('.wp-block-embark-background')?.querySelector(targetSelector);

		if (!targetElement) {
			return;
		}

		if (applyBackground) {
			// Get the image source (check both src and data-src for lazy loading)
			const imgSrc = img.currentSrc || img.src || img.dataset.src;

			if (imgSrc) {
				// Apply the image as background
				targetElement.style.backgroundImage = `url('${imgSrc}')`;

				// Hide the original image element
				img.style.display = 'none';
			}
		} else {
			// Remove the background image
			targetElement.style.backgroundImage = '';

			// Show the original image element
			img.style.display = '';
		}
	});
}

// Execute the function only after the entire DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
	const imgSelector = '.is-style-media-heading .wp-block-embark-background__media img';
	const targetSelector = '.is-style-media-heading .wp-block-embark-background__media';

	// Create a media query that matches screens larger than 850px
	const mediaQuery = window.matchMedia('(min-width: 851px)');

	// Function to handle the media query changes
	function handleMediaChange(e) {
		// Apply background on larger screens, restore original img on smaller screens
		moveImageAsBackground(imgSelector, targetSelector, e.matches);
	}

	// Initial check
	handleMediaChange(mediaQuery);

	// Listen for viewport changes
	mediaQuery.addEventListener('change', handleMediaChange);
});
